import ErrorApi from "./../utils/ErrorApi"
import JsonFetch from "./../utils/JsonFetch"

if (serverContextPath === null) {
    console.error("Global variable serverContextPath is not defined (is null)!");
}

export default class EprApi {
    static baseUrl =            `${serverContextPath}/api`;
    static epr =                EprApi.baseUrl + '/prestupky';

    static typy =               EprApi.epr + '/typy';

    static findTypyPrestupku(recidiva = null) {
        return ErrorApi.responseResolver(JsonFetch.get(EprApi.typy, {recidiva: recidiva}));
    }
}
